/* eslint-disable react/no-unknown-property */
import Config from 'common/config';
import AuthBackground from 'modules/auth/components/auth-background';
import Register from 'modules/auth/register';
import { AuthContainer } from 'modules/auth/style';
import { useRouter } from 'next/router';
import { NextSeo } from 'next-seo';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

export default function RegisterPage() {
  const { t } = useTranslation();
  const [step, setStep] = React.useState(1);
  const router = useRouter();

  return (
    <>
      <NextSeo
        title={t('common:title_register')}
        description={t('common:description_register')}
        canonical={Config.apiEndpoint + '/register'}
        openGraph={{
          type: 'website',
          url: Config.apiEndpoint + '/register',
          locale: router.locale,
          title: t('common:title_register'),
          description: t('common:description_register'),
        }}
      />
      <AuthContainer>
        <Register {...{ setStep, step }} />
        <AuthBackground />
      </AuthContainer>
    </>
  );
}
